import React, { useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Flex, Text, Heading, Image, Button, Select } from '@chakra-ui/core';
import theme, { colors } from '../../styles/theme-chakra';
import validEmail from '../../lib/validEmail';
import { subscribe } from '../../lib/subscribeToNewsletter';
import ReCAPTCHA from 'react-google-recaptcha';
import TextInput from '../shared/TextInput';
import { motion } from 'framer-motion';
import { MobileOnly, DesktopOnly } from '../shared/SizeOnly';

export const RELATIONSHIP_STATUS = [
  { text: 'Dating', value: 'dating' },
  { text: 'Living together', value: 'livingTogether' },
  { text: 'Engaged', value: 'engaged' },
  { text: 'Married', value: 'married' },
  { text: 'Divorced', value: 'divorced' },
  { text: 'Other', value: 'other' }
];

const SubscribeForm = () => {
  const { closeModal } = useStoreActions(actions => actions.modalDisplay);
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [relationshipType, setRelationshipType] = useState('');
  const [captcha, setCaptcha] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [profile, setProfile] = useState({});

  const updateFirstName = name => {
    setFirstName(name);
    setProfile({ ...profile, FNAME: name });
  };

  const updateRelationshipType = e => {
    setRelationshipType(e.target.value);
    setProfile({ ...profile, REL_ST: e.target.value });
  };

  const validForm = validEmail(email) && firstName.length > 0;

  const subscribeEmail = () => {
    if (validEmail(email)) {
      subscribe({
        email,
        list: 'master',
        profile: JSON.stringify(profile),
        source: 'magazine-signup-modal',
        sourceUrl: typeof window !== 'undefined' ? window.location.href : null
      });
      setSubmitted(true);
    } else {
      alert(
        `'${email}' doesnt look like a valid email address.  Please correct it and try again.`
      );
    }
  };

  return (
    <>
      <TextInput onChange={updateFirstName} placeholder="First Name" />
      <TextInput
        onChange={setEmail}
        placeholder="Your favorite email"
        onKeyUp={e => {
          if (e.key === 'Enter') {
            subscribeEmail();
          }
        }}
      />
      <Select
        mt="2rem"
        placeholder="Stage Of Your Relationship?"
        value={relationshipType}
        onChange={updateRelationshipType}
        variant="outline"
        border={`1px solid ${colors.black}`}
        borderColor={colors.black}
        focusBorderColor="#00000055"
        bg={colors.white}
      >
        {RELATIONSHIP_STATUS.map(rel => {
          return (
            <option key={`opt-${rel.value}`} value={rel.value}>
              {rel.text}
            </option>
          );
        })}
      </Select>
      <Flex mt="2rem">
        <ReCAPTCHA
          sitekey="6LcSUd0ZAAAAAFxDbVXlU585P3WZJwhE6_qNLFix"
          onChange={() => {
            setCaptcha(true);
          }}
        />
      </Flex>
      {submitted ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Button
            className="nav-link"
            p={['1rem']}
            mt={'2rem'}
            style={{
              backgroundColor: colors.green,
              borderRadius: '8px',
              width: '100%'
            }}
          >
            <Text as="span" fontWeight="semibold" color={colors.black} fontSize="md">
              You're on the list!
            </Text>
          </Button>
          <MobileOnly>
            <Button
              className="nav-link"
              onClick={closeModal}
              p={'1rem'}
              mt={'1rem'}
              style={{
                backgroundColor: colors.greenPea,
                borderRadius: '8px',
                width: '100%'
              }}
            >
              <Text as="span" fontWeight="bold" color={colors.white} fontSize="md">
                Close
              </Text>
            </Button>
          </MobileOnly>
        </motion.div>
      ) : (
        <Button
          className="nav-link"
          onClick={subscribeEmail}
          p={['1rem']}
          mt={'2rem'}
          style={{
            backgroundColor: colors.greenPea,
            borderRadius: '8px'
          }}
          disabled={!validForm}
        >
          <Text as="span" fontWeight="bold" color={colors.white} fontSize="md">
            Sign up now
          </Text>
        </Button>
      )}
    </>
  );
};

const GetStartedModal = ({ newsletterOnly = false }) => {
  const Signup = () => {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Flex
          direction={['column', 'row']}
          px={[0, 8]}
          justify="space-between"
          alignItems="center"
          pb={6}
        >
          <Flex width={['50%', '48%']} alignItems="center" justify="center">
            <Image
              data-pin-nopin="true"
              src={`https://zeta-site-assets.s3.us-east-2.amazonaws.com/homepage/hero_${Math.floor(
                Math.random() * 14
              ) + 1}.png`}
            />
          </Flex>
          <Flex width={['100%', '48%']} direction="column">
            <Heading
              py={[4, 4]}
              fontSize={[theme.fontSizes[4], theme.fontSizes[6]]}
              as="h1"
              fontWeight="semibold"
            >
              Let's see more of each other.
            </Heading>
            <DesktopOnly>
              <Text fontSize={theme.fontSizes[2]} as="h2">
                Subscribe to our monthly Money Date
                <br /> newsletter filled with tips guaranteed to <br />
                help you achieve #RelationshipGoals.
              </Text>
            </DesktopOnly>
            <MobileOnly>
              <Text fontSize={theme.fontSizes[2]} as="h2">
                Subscribe to our monthly Money Date newsletter filled with tips guaranteed
                to help you achieve #relationshipGoals.
              </Text>
            </MobileOnly>
            <Flex direction="column" width={['100%', '304px']}>
              <SubscribeForm />
            </Flex>
          </Flex>
        </Flex>
      </motion.div>
    );
  };

  return <Signup />;
};

export default GetStartedModal;
